<template>
  <b-modal
    v-model="showModal"
    size="lg"
    id="crtcreator-content-category-modal"
    :title="edited.id ? 'Edit content category' : 'Add content category'"
    :ok-title="isFormLoading ? 'Saving...' : 'Save'"
    :ok-disabled="isFormLoading"
    cancel-variant="outline-secondary"
    @ok="onSubmit($event)"
  >
    <b-form>
      <b-form-group label="Name" label-for="content-category-name">
        <b-form-input
          id="content-category-name"
          v-model="edited.name"
          placeholder="Name"
        />
        <small
          v-if="errors.name"
          class="text-danger"
        >{{ errors.name }}</small>
      </b-form-group>
      <b-form-group label="Description" label-for="content-category-description">
        <b-form-textarea
          id="content-category-description"
          v-model="edited.description"
          rows="3"
          placeholder="Optional description"
        />
      </b-form-group>
      <b-form-group label="Hashtags" label-for="content-category-hashtags">
        <b-form-textarea
          id="content-category-hashtags"
          v-model="edited.hashtags"
          rows="2"
          max-rows="6"
          placeholder="Optional hashtags"
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BFormTextarea, BModal,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { toastFailure, toastSuccess } from '@/libs/toastification'

const defaults = () => ({
  id: null,
  name: '',
  description: '',
  hashtags: '',
})

function firstError(value) {
  if (Array.isArray(value)) {
    return value[0] || ''
  }
  return value || ''
}

export default {
  components: {
    BForm, BFormGroup, BFormInput, BFormTextarea, BModal,
  },
  props: {
    record: { type: Object, default: null },
    clickDate: { type: Date, default: null },
  },
  emits: ['saved'],
  data() {
    return {
      showModal: false,
      isFormLoading: false,
      edited: defaults(),
      errors: {},
    }
  },
  watch: {
    clickDate() {
      this.errors = {}
      if (this.record && this.record.id) {
        this.edited = {
          id: this.record.id,
          name: this.record.name || '',
          description: this.record.description || '',
          hashtags: this.record.hashtags || '',
        }
      } else {
        this.edited = defaults()
      }
      this.showModal = true
    },
  },
  methods: {
    ...mapActions({
      addItem: 'crtcreator/contentCategories/addItem',
      updateItem: 'crtcreator/contentCategories/updateItem',
    }),
    applyServerErrors(error) {
      const payload = error?.response?.data
      if (!payload || typeof payload !== 'object') {
        return false
      }
      const next = {}
      if (payload.name) next.name = firstError(payload.name)
      if (Object.keys(next).length) {
        this.errors = next
        return true
      }
      return false
    },
    async onSubmit(event) {
      event.preventDefault()
      this.errors = {}
      if (!String(this.edited.name || '').trim()) {
        this.errors.name = 'Name is required'
      }
      if (Object.keys(this.errors).length) return

      this.isFormLoading = true
      const payload = {
        name: this.edited.name,
        description: String(this.edited.description || '').trim() || null,
        hashtags: String(this.edited.hashtags || '').trim() || null,
      }
      try {
        let saved
        if (this.edited.id) {
          saved = await this.updateItem({ id: this.edited.id, payload })
          toastSuccess('Successfully updated')
        } else {
          saved = await this.addItem(payload)
          toastSuccess('Successfully added')
        }
        this.showModal = false
        this.$emit('saved', saved)
      } catch (e) {
        if (!this.applyServerErrors(e)) {
          toastFailure('Failed to save')
        }
      } finally {
        this.isFormLoading = false
      }
    },
  },
}
</script>
